import { useState, useEffect } from "react";
import {
  Dialog,
  RadioButton,
  OverlayTrigger,
  Tooltip,
} from "@rio-cloud/rio-uikit";
import Map from "@rio-cloud/rio-uikit/Map";
import Marker from "@rio-cloud/rio-uikit/Marker";
import SingleMapMarker from "@rio-cloud/rio-uikit/SingleMapMarker";
import { Dealership } from "../../../../../../../models/dealership";
import { useDispatchChooseDealership } from "../../../../../../../hooks/useDispatch";
import ErrorDialog from "../../../../../../dialogs/ErrorDialog";
import { useSelector } from "react-redux";
import { getUserProfile } from "../../../../../../../configuration/login/loginSlice";
import Checkbox from "@rio-cloud/rio-uikit/Checkbox";
import AddressSearch from "../../../../../../form/AddressSearch";
import { getDistanceBetweenTwoLocations } from "../../../../../../../utils/locationUtils";

interface ChooseDealershipDialogProps {
  show: boolean;
  onClose: () => void;
  onChooseDealership: (dn: string, route: string, originLocation: string, destinationLocation: string) => Promise<void>;
  assetId: string;
  occurrenceType?: string;
  chassis?: string;
  ocurrenceId?: string;
  vehicleName?: string;
  dispatchId?: string;
}

const ChooseDealershipDialog = (props: ChooseDealershipDialogProps) => {
  const userProfile = useSelector(getUserProfile);

  const {
    saveLoading,
    setSaveLoading,
    addressForm,
    setAddressForm,
    searchDealershipTerm,
    setSearchDealershipTerm,
    dealerships,
    setDealershipSelected,
    dealershipSelected,
    createRoutingRoute,
    createRouteError,
    setCreateRouteError,
    enableLocation,
    handleSetEnableLocation,
    assetGeoLocation,
    setAssetGeoLocation,
  } = useDispatchChooseDealership({
    show: props.show,
    responsibleId: userProfile?.sub?.split(":")[1] ?? "",
    assetId: props.assetId,
    occurrenceType: props.occurrenceType,
    chassis: props.chassis,
    ocurrenceId: props.ocurrenceId,
    dispatchId: props.dispatchId,
    vehicleName: props.vehicleName,
  });
  
  return (
    <>
      <Dialog
        show={props.show}
        onClose={props.onClose}
        showCloseButton
        bsSize={Dialog.SIZE_XL}
        title="Escolha da concessionária"
        body={
          <div className="flex chooseConcessionaria h-[85vh]">
            <div className="w-1/3 overflow-auto p-10 padding-right-20 h-[85vh] pb-[200px]">
              <h2 className="text-size-h2 text-color-black font-semibold text-uppercase">
                ESCOLHA SUA CONCESSIONÁRIA
              </h2>
              <p className="text-color-status-resting text-size-16 padding-top-10">
                Escolha sua concessionária favorita ou selecione outra da lista
                para realizar os serviços.
              </p>

              <div className="border rounded p-8 my-4">
                <strong>Localização do veículo</strong>

                <div className="padding-x-10 padding-y-20">
                  <Checkbox
                    checked={enableLocation}
                    onChange={() => handleSetEnableLocation(!enableLocation)}
                  >
                    Inserir local manualmente
                  </Checkbox>
                </div>

                <div>Geolocalização</div>
                <div className="flex justify-between gap-6">
                  <div className="form-group w-1/2">
                    <label htmlFor="lat">Latitude:</label>
                    <input
                      id="lat"
                      placeholder="Latitude"
                      value={assetGeoLocation?.lat?.toFixed(6) || "-"}
                      className="form-control"
                      disabled
                    />
                  </div>

                  <div className="form-group w-1/2">
                    <label htmlFor="lng">Longitude:</label>
                    <input
                      id="lng"
                      placeholder="Longitude"
                      value={assetGeoLocation?.lng?.toFixed(6) || "-"}
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>

                <div className="pt-8">
                  <div>Localização do veículo</div>

                  <div className="form-group">
                    <label htmlFor="address">Endereço*:</label>
                    <AddressSearch
                      value={addressForm.label ?? `${[addressForm.address, addressForm.neighborhood, addressForm.city, addressForm.state].filter(Boolean).join(", ")}`}
                      getAddress={async (address) => {
                        setAddressForm({
                          ...addressForm,
                          address: address.street,
                          neighborhood: address.district,
                          city: address.city,
                          state: address.state,
                          label: address.label,
                          geoLocation: address.geoLocation,
                        });
                        setAssetGeoLocation(address.geoLocation);
                      }}
                      disabled={!enableLocation}
                    />
                  </div>
                </div>

                <div className="new-concessionaria mt-10">
                  <div className="flex">
                    <div className="form-group w-full">
                      <label htmlFor="1">Selecionar concessionária</label>
                      {/* <div
                          className="select-concessionaria cursor-pointer flex justify-between items-center gap-6 padding-left-10 padding-right-10"
                          onClick={() => searchDealerships()}
                        >
                          <div className="flex items-center gap-6">
                            <img src="assets/images/building.svg" alt="" />
                            <span className="text-color-gray">
                              Selecionar concessionária
                            </span>
                          </div>
                          {loading ? (
                            <div className="spinner">
                              <div />
                              <div />
                              <div />
                              <div />
                            </div>
                          ) : (
                            <span className="rioglyph rioglyph-chevron-down text-size-10"></span>
                          )}
                        </div> */}

                      <div className="search-concessionaria">
                        <div className="form-group form-group-lg">
                          <div className="input-group">
                            <span className="input-group-addon">
                              <span className="rioglyph rioglyph-search"></span>
                            </span>
                            <input
                              id="input7"
                              className="form-control"
                              type="text"
                              placeholder="Procurar concessionária"
                              onChange={(e) =>
                                setSearchDealershipTerm(e.target.value)
                              }
                              value={searchDealershipTerm}
                            />
                          </div>
                        </div>

                        {dealerships.length === 0 && (
                          <div className="flex justify-center padding-top-10">
                            <span className="text-color-gray">
                              Nenhuma concessionária encontrada
                            </span>
                          </div>
                        )}

                        {dealerships
                          .map((foundDealership: Dealership) => {
                            foundDealership.distance =
                              getDistanceBetweenTwoLocations(
                                assetGeoLocation ?? { lat: -23.550573750495325, lng: -46.64411772565403 },
                                foundDealership?.geoLocation
                              );
                            return foundDealership;
                          })
                          .sort(
                            (a, b) => (a.distance ?? 0) - (b.distance ?? 0)
                          )
                          .map((foundDealership: Dealership) => (
                            <div
                              className={`flex items-center concessionaria-options w-full ${dealershipSelected?.dn ===
                                foundDealership.id
                                ? "selected"
                                : ""
                                }`}
                            >
                              <RadioButton
                                name="radios"
                                id="optionsRadios1"
                                value="option1"
                                checked={
                                  foundDealership.id ===
                                  dealershipSelected?.dn
                                }
                                onChange={() => {
                                  setDealershipSelected({
                                    dn: foundDealership.id,
                                    address: `${foundDealership.address}, ${foundDealership.neighborhood}, ${foundDealership.city}, ${foundDealership.state}`,
                                  });
                                }}
                              />
                              <div className="flex justify-start items-center flex-wrap
                              ">
                                <span className="text-size-14 text-ellipsis whitespace-nowrap overflow-hidden">
                                  dn:
                                  <strong className="ml-2 text-size-14">
                                  {foundDealership.id} - 
                                  </strong>
                                </span>
                                <span className="text-size-14 text-ellipsis whitespace-nowrap overflow-hidden">
                                  <strong className="ml-2 text-size-14">
                                    {foundDealership.name}
                                  </strong>
                                </span>
                                <span className="card-km text-size-14 font-semibold">
                                  {Math.round(
                                    foundDealership.distance ?? 0
                                  )}{" "}
                                  Km
                                </span>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip
                                      id="address-tooltip"
                                      allowOnTouch
                                    >
                                      <div className="flex flex-col padding-10">
                                        <p>
                                          {[
                                            foundDealership.address,
                                            foundDealership.neighborhood,
                                            foundDealership.city,
                                            foundDealership.state,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                        </p>
                                      </div>
                                    </Tooltip>
                                  }
                                >
                                  <span className="text-size-14 truncate">
                                    {[
                                      foundDealership.city,
                                      foundDealership.state,
                                    ]
                                      .filter(Boolean)
                                      .join(", ")}
                                  </span>
                                </OverlayTrigger>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <div className="flex justify-end">
                <button
                  onClick={async () => {
                    setSaveLoading(true);
                    const { routeId, origin, destination } = await createRoutingRoute();
                    if (routeId) {
                      await props.onChooseDealership(
                        dealershipSelected?.dn ?? "",
                        routeId,
                        origin ?? "",
                        destination ?? ""
                      );
                    }
                    setDealershipSelected(null);
                    setAddressForm({
                      address: "",
                      neighborhood: "",
                      city: "",
                      state: "",
                      label: "",
                      geoLocation: undefined,
                    });
                    setAssetGeoLocation(undefined);
                    setSearchDealershipTerm("");
                    setSaveLoading(false);
                  }}
                  className={`px-4 py-2 btn btn-primary ${saveLoading ? "btn-loading" : ""
                    }`}
                  disabled={!dealershipSelected || saveLoading}
                >
                  {saveLoading
                    ? "Enviando acionamento..."
                    : "Enviar acionamento"}
                </button>
              </div>
            </div>

            <div className="w-2/3">
              <Map
                credentials={{ apikey: import.meta.env.VITE_HERE_MAPS_API_KEY }}
                center={{
                  lat: enableLocation && assetGeoLocation?.lat ?
                    assetGeoLocation?.lat : -23.550573750495325,
                  lng: enableLocation && assetGeoLocation?.lng ?
                    assetGeoLocation?.lng : -46.64411772565403,
                }}
                zoom={10}
                hideMapSettings
              >
                <Marker
                  position={{
                    lat: enableLocation && assetGeoLocation?.lat ?
                      assetGeoLocation?.lat : -23.550573750495325,
                    lng: enableLocation && assetGeoLocation?.lng ?
                      assetGeoLocation?.lng : -46.64411772565403,
                  }}
                  icon={
                    <SingleMapMarker
                      iconNames={["truck"]}
                      markerColor="bg-map-marker-asset"
                      active
                    />
                  }
                />

                {dealerships
                  .filter(
                    (dealership: Dealership) =>
                      dealership.geoLocation?.lat &&
                      dealership.geoLocation?.lng
                  )
                  .map((dealership: Dealership) => (
                    <Marker
                      key={dealership.id}
                      position={{
                        lat: dealership.geoLocation?.lat ?? 0,
                        lng: dealership.geoLocation?.lng ?? 0,
                      }}
                      icon={
                        <SingleMapMarker
                          iconNames={["factory"]}
                          markerColor="bg-map-marker-poi"
                          active
                          name={dealership.name}
                        />
                      }
                    />
                  ))}
              </Map>
            </div>
          </div>
        }
      />

      <ErrorDialog
        show={!!createRouteError}
        onClose={() => setCreateRouteError(null)}
        title="Erro ao criar rota"
        body={createRouteError ?? ""}
      />
    </>
  );
};

export default ChooseDealershipDialog;
